import React from 'react';
import { Card, Row, Col, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTools, faRocket } from '@fortawesome/free-solid-svg-icons';

const PageInDevelopment = ({ title, description, expectedFeatures = [] }) => {
  return (
    <div>
      <Row className="g-3 mb-4">
        <Col xs={12}>
          <Card className="border-0 shadow-sm">
            <Card.Body className="text-center p-5">
              <div className="mb-4">
                <FontAwesomeIcon 
                  icon={faTools} 
                  size="3x" 
                  className="text-warning mb-3"
                />
                <h2 className="fw-bold mb-2">
                  {title || 'Página en Desarrollo'}
                </h2>
                <p className="text-muted fs-5 mb-0">
                  {description || 'Esta funcionalidad estará disponible próximamente'}
                </p>
              </div>

              <Alert variant="info" className="border-0 mb-4">
                <div className="d-flex align-items-center">
                  <FontAwesomeIcon icon={faRocket} className="me-2" />
                  <strong>¡Estamos trabajando en ello!</strong>
                </div>
                <small className="d-block mt-2">
                  El equipo de desarrollo está construyendo esta funcionalidad. 
                  Mientras tanto, puedes utilizar las otras secciones disponibles.
                </small>
              </Alert>

              {expectedFeatures.length > 0 && (
                <div className="text-start">
                  <h5 className="fw-bold mb-3">Funcionalidades Previstas:</h5>
                  <ul className="list-unstyled">
                    {expectedFeatures.map((feature, index) => (
                      <li key={index} className="mb-2">
                        <FontAwesomeIcon 
                          icon="check-circle" 
                          className="text-success me-2" 
                        />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              <div className="mt-4">
                <button 
                  className="btn btn-outline-primary"
                  onClick={() => window.history.back()}
                >
                  ← Volver Atrás
                </button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default PageInDevelopment; 